module.exports = __webpack_public_path__ + "img/CW_Robert_Ellis+David_Garza+Meshell-4136.d254c02b.jpg";